import { useEffect, useState } from 'react'
import type { Choice } from '../../components/Contexts/AdaptiveCardContext'

const useCurrentValue = (instanceId?: string): Record<string, string | number | Array<string> | Array<number> | Choice | boolean> | undefined => {
  const [current, setCurrent] = useState<Record<string, string | number | Array<string> | Array<number> | Choice | boolean> | undefined>(undefined)

  const handleChange = (e: CustomEvent): void => {
    if (instanceId) {
      e.detail.instanceId === instanceId && setCurrent(e.detail.value)
    } else {
      setCurrent(e.detail.value)
    }
  }

  useEffect(() => {
    document.addEventListener('retorik_currentValue', (e) => handleChange(e))
    // Dispatch event on mount to get the updated value in stead of the default one
    document.dispatchEvent(new Event('retorik_call_currentValue'))

    return () => {
      document.removeEventListener('retorik_currentValue', (e) => handleChange(e))
    }
  }, [])

  return current
}

export default useCurrentValue
